let mutations = {
    UPDATE_ROWS(state, rows) {
        state.selectAllChecked = false;
        state.rows = rows;
        state.statelessRowData = JSON.parse(JSON.stringify(rows));
        state.activeFilters = {};
    },

    REMOVE_FILTER(state, info) {
        if (!('column' in info) || !('filter' in info)) {
            return false;
        }
        const filter = info.filter;

        state.rows.filter(row => row.selected || row.expanded).forEach(row => {
            Vue.set(row, 'selected', false)
            Vue.set(row, 'expanded', false)
        })

        state.selectAllChecked = false

        state.rows.filter(row => !row.hidden).forEach((row, index) => {
            if (_.has(row, 'data', info.column) && row.data[info.column] && row.data[info.column] == filter) {
                Vue.set(row, 'hidden', true)
            }
        })

        state.activeFilters[info.column].splice(state.activeFilters[info.column].indexOf(info.filter), 1);

        if (state.activeFilters[info.column].length === 0) {
            delete state.activeFilters[info.column]
        }

        if (Object.keys(state.activeFilters).length === 0) {
            state.rows.filter(row => row.hidden).forEach((row, index) => {
                Vue.set(row, 'hidden', false)
            })
        }
        else {
            let rows = state.rows.filter(row => row.hidden)
            for (let column in state.activeFilters) {
                rows = rows.filter(row => _.has(row, 'data', column) && row.data[column] && state.activeFilters[column].includes(row.data[column]))
            }
            rows.forEach((row, index) => {
                Vue.set(row, 'hidden', false)
            })
        }
    },

    ADD_FILTER(state, info) {
        if (!('column' in info) || !('filter' in info)) {
            return false;
        }

        const filter = info.filter;

        state.rows.filter(row => row.selected || row.expanded).forEach(row => {
            Vue.set(row, 'selected', false)
            Vue.set(row, 'expanded', false)
        })

        state.selectAllChecked = false

        if (!_.has(state.activeFilters, info.column)) {
            Vue.set(state.activeFilters, info.column, [])
        }

        state.activeFilters[info.column].push(filter);

        // First filter
        if (Object.keys(state.activeFilters).length === 1 && state.activeFilters[info.column].length === 1) {
            state.rows.forEach((row, index) => {
                if (_.has(row, 'data', info.column) && row.data[info.column] && row.data[info.column] == filter) {
                    Vue.set(row, 'hidden', false)
                }
                else {
                    Vue.set(row, 'hidden', true)
                }
            })
        }
        // Only filtering on 1 column
        else if (Object.keys(state.activeFilters).length === 1) {
            state.rows.filter(row => row.hidden).forEach((row, index) => {
                if (_.has(row, 'data', info.column) && row.data[info.column] && row.data[info.column] == filter) {
                    Vue.set(row, 'hidden', false)
                }
            })
        }
        // Filtering on multiple columns
        else {
            state.rows.filter(row => !row.hidden).forEach((row, index) => {
                if (!_.has(row, 'data', info.column) || !row.data[info.column] || row.data[info.column] != filter) {
                    Vue.set(row, 'hidden', true)
                }
            })

            let rows = state.rows.filter(row => row.hidden)
            for (let column in state.activeFilters) {
                rows = rows.filter(row => _.has(row, 'data', column) && row.data[column] && state.activeFilters[column].includes(row.data[column]))
            }
            rows.forEach((row, index) => {
                Vue.set(row, 'hidden', false)
            })
        }
    },

    TOGGLE_IN_PROGRESS(state) {
        state.showInProgress = !state.showInProgress;
    },

    SELECT_ROW(state, row) {
        Vue.set(row, 'selected', true);
    },

    DESELECT_ROW(state, row) {
        Vue.set(row, 'selected', false);
    },

    CHANGE_START_DATE(state, date) {
        if (date != state.startDate) {
            state.startDate = date;
            state.needToSearch = true;
        }
    },

    CHANGE_END_DATE(state, date) {
        if (date != state.endDate) {
            state.endDate = date;
            state.needToSearch = true;
        }
    },

    NEED_TO_SEARCH(state, needToSearch) {
        state.needToSearch = needToSearch;
    },

    SELECT_ALL_CHECKED(state, checked) {
        state.selectAllChecked = checked;
    },

    SHOW_BALANCE_COLUMN(state, visible) {
        state.showBalanceColumn = visible;
    },

    UPDATE_CLIENT_SAMPLE_TYPES(state, items) {
        state.clientSampleTypes = items;
    },

    UPDATE_SELECTED_SAMPLE_TYPES(state, selection) {
        state.selectedSampleTypes = selection;
    },

    UPDATE_DOCUMENT_TYPES(state, types) {
        state.docTypes = types;
    },

    UPDATE_SELECTED_DOC_TYPE_CODES(state, codes) {
        for (var i = 0; i < state.docTypes.length; i++) {
            Vue.set(state.docTypes[i], 'selected', codes.indexOf(state.docTypes[i].document_type_cd) != -1);
        }
    },

    UPDATE_USER_ACCOUNT_ROLES(state, userAccountRoles) {
        state.userAccountRoles = {};
        userAccountRoles.forEach(item => {
            if (item.roles) {
                var roles = (Array.isArray(item.roles)) ? item.roles : item.roles.split(',');
                if (item.account_nbr) Vue.set(state.userAccountRoles, item.account_nbr, roles);
            }
        })
    },

    UPDATE_USER_IS_SYS_ADMIN(state, is_sys_admin) {
        state.userIsSysAdmin = is_sys_admin;
    },

    SET_ITEM_VALUE(state, params) {
        if (_.has(params, 'item') && _.has(params, 'key') && _.has(params, 'value')) {
            Vue.set(params.item, params.key, params.value);
        }
    },

    GET_REPORT_FORMATS(state, account_nbr) {
        axios.get('/documents/reports/formats/' + account_nbr)
            .then((response) => {
                if (response.data) {
                    Vue.set(state.reportFormats, account_nbr, response.data);
                }
            });
    },

    EMAIL_REPORTS(state, params) {
        axios.put('/documents/reports/email', params)
            .then(response => {
                toastr.success('Please allow up to 15 minutes for them to arrive.', 'Your reports have been scheduled for delivery!');
            })
            .catch(error => {
                toastr.error('If this problem continues, please contact Midwest Laboratories.', 'Error!');
            });
    },
    SET_OUTLIERS_ONLY(state, value) {
        state.outliersOnly = !!value;
    },

    SET_PROJECT_PO(state, value) {
        state.projectPO = value ? String(value) : '';
    },
};

export default mutations;


// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/documents/mutations.js